<div class="govuk-width-container">
  <div class="govuk-grid-row">
    <div class="govuk-grid-column-two-thirds">
      <div class="app-prose-scope">
        <h1 id="privacy-policy">Privacy policy</h1>
        <p>We collect certain information and data about you when you use this service</p>
        <p>We collect:</p>
        <ul>
          <li>questions, queries or feedback you leave</li>
          <li>your email address, if you contact us</li>
          <li>your Internet Protocol (IP) address, and which version of web browser you used</li>
          <li>information on how you use the site, using <a href="/cookies">cookies</a> and page-tagging techniques</li>
        </ul>
        <p>We use this data to:</p>
        <ul>
          <li>improve the site by monitoring how you use it</li>
          <li>gather feedback to improve our services</li>
          <li>respond to any feedback you send us, if you’ve asked us to.</li>
        </ul>

        <h2 id="where-your-data-is-stored">Where your data is stored</h2>
        <p>We store all our data on secure servers in the UK.</p>

        <h2 id="keeping-your-data-secure">Keeping your data secure</h2>
        <p>Sending information over the internet is generally not completely secure, and we cannot guarantee the security of your data while it’s in transit.</p>
        <p><strong>Any data you send is at your own risk</strong>.</p>
        <p>We have procedures and security features in place to keep your data secure once we receive it.</p>

        <h2 id="disclosing-your-information">Disclosing your information</h2>
        <p>We will not share your information with any other organisations for marketing, market research or commercial purposes, and we do not pass on your details to other websites.</p>

        <h2 id="email">Email</h2>
        <p>We use a company called SendGrid to help us with our emails so that you can reliably receive advice directly to your inbox.</p>
        <p>You can find SendGrid's privacy policy <a href="https://sendgrid.com/policies/privacy/" title="Link to SendGrid privacy policy" target="_blank">here</a>.</p>

        <h2 id="links-to-other-websites">Links to other websites</h2>
        <p>This service contains links to other websites.</p>
        <p>This privacy policy only applies to this service ({{meta.serviceName}}), and does not cover other external services that we link to. These services have their own terms and conditions and privacy policies.</p>

        <h3 id="following-a-link-to-another-website">Following a link to another website</h3>
        <p>If you go to another website from this one, read the privacy policy on that website to find out what it does with your information.</p>

        <h3 id="following-a-link-to-this-service-from-another-website">Following a link to this service from another website</h3>
        <p>If you come to this service from another website, we may receive information from the other website. We do not use this data. You should read the privacy policy of the website you came from to find out more about this.</p>

      </div>
    </div>
  </div>

</div>
